import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { GridDots } from '../components/GridDots'

export const AuthCallback = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession()
        
        if (error) {
          throw error
        }

        if (session) {
          // Successfully authenticated
          navigate('/dashboard')
        } else {
          // No session found
          navigate('/login')
        }
      } catch (error) {
        console.error('Error handling auth callback:', error)
        navigate('/login')
      }
    }

    handleAuthCallback()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1E1E2E] relative">
      <GridDots />
      <div className="max-w-md w-full space-y-8 p-8 bg-[#2A2A3C] rounded-lg relative z-10">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#6C63FF]"></div>
          <h2 className="mt-4 text-center text-xl font-semibold text-white">Completing sign in...</h2>
          <p className="mt-2 text-center text-sm text-gray-400">
            Please wait while we complete your authentication
          </p>
        </div>
      </div>
    </div>
  )
} 